class ToolkitCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let self = this;
    const id = this.dataset.selector;
    const element = document.querySelector("#swiper-" + id);
    const config = {
      dots: false,
      loop: true,
      arrows: false,
      autoplay: true,
      spaceBetween: 10,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        880: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
      },
    };

    new Swiper(element, config);
    element.classList.add("block-swiper__initialize");
  }
}
customElements.define("toolkit-carousel", ToolkitCarousel);
